module.exports = __webpack_public_path__ + "img/MES12Indice4_cutout.1af0c87e.png";